// reducers.js
import { combineReducers } from "redux";

const initialState = {
  cartItems: [],
};
// Define individual reducers
const cartItemsReducer = (state = initialState, action) => {
  // Handle actions related to cartItems
  switch (action.type) {
    case "ADD_TO_CART":
      const { item, quantity: newAddQty } = action.payload;
      const addItemId = item.id;
      const addItem = state.cartItems.find((item) => item.id === addItemId);

      if (addItem) {
        // alert(`[Redux] Updating ${item.title}: ${addItem.quantity} + ${newAddQty} = ${addItem.quantity + newAddQty}`);
        const newState = {
          ...state,
          cartItems: state.cartItems.map((item) =>
            item.id === addItemId
              ? { ...item, quantity: item.quantity + newAddQty }
              : item
          ),
        };
        return newState;
      } else {
        // alert(`[Redux] Adding new item ${item.title} to cart`);
        const newState = {
          ...state,
          cartItems: [...state.cartItems, { ...item, quantity: 1 }],
        };
        return newState;
      }
    case "REMOVE_FROM_CART":
      const { item: payloadItem, quantity: newSubQty } = action.payload;
      const removeItemId = payloadItem.id;
      const removeItem = state.cartItems.find(
        (item) => item.id === removeItemId
      );

      if (removeItem.quantity > 1) {
        return {
          ...state,
          cartItems: state.cartItems.map((item) =>
            item.id === removeItemId
              ? { ...item, quantity: item.quantity - newSubQty }
              : item
          ),
        };
      } else {
        return {
          ...state,
          cartItems: state.cartItems.filter((item) => item.id !== removeItemId),
        };
      }
    case "REMOVE_FULL_ITEM_FROM_CART":
      const { id: removeFullItemId } = action.payload;
      return {
        ...state,
        cartItems: state.cartItems.filter(
          (item) => item.id !== removeFullItemId
        ),
      };
    case "CLEAR_CART":
      return {
        ...state,
        cartItems: [],
      };
    case "REPLACE_CART":
      return {
        ...state,
        cartItems: action.payload, // Replace cart items with the new items
      };
    case "MERGE_WITH_EXISTING_ORDER":
      // Merge existing order items with current cart
      const existingOrderItems = action.payload || [];
      const currentCartItems = state.cartItems || [];
      
      // Create a map of current cart items for easier lookup
      const cartItemsMap = {};
      currentCartItems.forEach(item => {
        cartItemsMap[item.id] = item;
      });
      
      // Process existing order items
      const mergedItems = [...currentCartItems];
      existingOrderItems.forEach(existingItem => {
        const formattedItem = {
          id: existingItem.id || existingItem.product_id,
          title: existingItem.title || existingItem.name || existingItem.product_name,
          price: parseFloat(existingItem.price || existingItem.salesprice || 0),
          quantity: parseInt(existingItem.quantity || existingItem.expectedqty || 0),
          category: existingItem.category,
          brand: existingItem.brand,
          type: existingItem.type,
          availableQty: parseInt(existingItem.availableQty || existingItem.availableqty || 0)
        };
        
        const existingInCart = cartItemsMap[formattedItem.id];
        if (existingInCart) {
          // Item exists in both new cart and existing order
          // For NEW→EXISTING conversion, keep the NEW cart quantity (user's current selection)
          // The existing order quantity will be shown separately in the existing order display
          console.log(`Item ${formattedItem.title} exists in both - keeping NEW cart quantity: ${existingInCart.quantity}`);
          // Don't modify existingInCart.quantity - keep the new cart quantity as-is
        } else {
          // Item only exists in existing order - add it to cart
          console.log(`Adding existing order item to cart: ${formattedItem.title} x${formattedItem.quantity}`);
          mergedItems.push(formattedItem);
        }
      });
      
      return {
        ...state,
        cartItems: mergedItems,
      };
    // ...
    default:
      return state;
  }
};

const selectedBrandReducer = (state = null, action) => {
  // Handle actions related to selectedBrand
  switch (action.type) {
    case "UPDATE_SELECTED_BRAND":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const selectedCategoryReducer = (state = null, action) => {
  // Handle actions related to selectedCategory
  switch (action.type) {
    case "UPDATE_SELECTED_CATEGORY":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const BrandListReducer = (state = null, action) => {
  // Handle actions related to selectedCategory
  switch (action.type) {
    case "UPDATE_BRAND_LIST":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const CategoryListReducer = (state = null, action) => {
  // Handle actions related to selectedCategory
  switch (action.type) {
    case "UPDATE_CATEGORY_LIST":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const ProductListReducer = (state = null, action) => {
  switch (action.type) {
    case "UPDATE_PRODUCT_LIST":
      return action.payload;
    case "UPDATE_PRODUCT_AVAILABILITY":
      if (!state || !action.payload) return state;
      return state.map(product => {
        const update = action.payload.find(u => u.id === product.id);
        return update ? { ...product, availableQty: update.availableQty } : product;
      });
    default:
      return state;
  }
};

const UserProfileReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_USER_PROFILE":
      return action.payload;
    case "UPDATE_USER_PROFILE_DETAILS":
      return {
        ...state,
        contactname: action.payload.contactname,
        contactphone: action.payload.contactphone,
        postalcode: action.payload.postalcode,
      };
    // ...
    default:
      return state;
  }
};

const SessionTokenReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_SESSION_TOKEN":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const ThankYouMessageReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_THANKYOU_MESSAGE":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const AgentReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_AGENT":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const SelectedStoreReducer = (state = null, action) => {
  // Handle actions related to selected store
  switch (action.type) {
    case "UPDATE_SELECTED_STORE":
      return action.payload;
    default:
      return state;
  }
};

const DeliveryTimeSlotReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_DELIVERY_TIME_SLOT":
      return action.payload;
    case "CLEAR_DELIVERY_TIME_SLOTS":
      return null;
    // ...
    default:
      return state;
  }
};

const SelectedTimeSlotReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_SELECTED_TIME_SLOT":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const TotalCostReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_TOTAL_COST":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const CheckoutCommentReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_CHECKOUT_COMMENT":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const SurchargeChargeListReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_SURCHARGE_CHARGE_LIST":
      return action.payload;
    case "CLEAR_SURCHARGE_CHARGE_LIST":
      return [];
    // ...
    default:
      return state;
  }
};

const DeliveryChargeListReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_DELIVERY_CHARGE_LIST":
      return action.payload;
    case "CLEAR_DELIVERY_CHARGE_LIST":
      return [];
    // ...
    default:
      return state;
  }
};

const ExclusivePromotionChargeListReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_EXCLUSIVE_PROMOTION_CHARGE_LIST":
      return action.payload;
    case "CLEAR_EXCLUSIVE_PROMOTION_CHARGE_LIST":
      return [];
    // ...
    default:
      return state;
  }
};

const ConcurrentPromotionChargeListReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_CONCURRENT_PROMOTION_CHARGE_LIST":
      return action.payload;
    case "CLEAR_CONCURRENT_PROMOTION_CHARGE_LIST":
      return [];
    // ...
    default:
      return state;
  }
};

const RequiredDeliveryChargesReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_REQUIRED_DELIVERY_CHARGES":
      return action.payload;
    case "CLEAR_REQUIRED_DELIVERY_CHARGES":
      return [];
    // ...
    default:
      return state;
  }
};

const RequiredSurchargeChargesReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_REQUIRED_SURCHARGE_CHARGES":
      return action.payload;
    case "CLEAR_REQUIRED_SURCHARGE_CHARGES":
      return [];
    // ...
    default:
      return state;
  }
};

const RequiredExclusivePromotionChargesReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_REQUIRED_EXCLUSIVE_PROMOTION_CHARGES":
      return action.payload;
    case "CLEAR_REQUIRED_EXCLUSIVE_PROMOTION_CHARGES":
      return [];
    // ...
    default:
      return state;
  }
};

const RequiredConcurrentPromotionChargesReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_REQUIRED_CONCURRENT_PROMOTION_CHARGES":
      return action.payload;
    case "CLEAR_REQUIRED_CONCURRENT_PROMOTION_CHARGES":
      return [];
    // ...
    default:
      return state;
  }
};

const CSRFTokenReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_CSRF_TOKEN":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const ProductTypeListReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_PRODUCT_TYPE_LIST":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const SelectedProductTypeReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_SELECTED_PRODUCT_TYPE":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const RouteDetailsReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_ROUTE_DETAILS":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const BaseManualPricingReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_BASE_MANUAL_PRICING":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const AgentPolicyManualPricingReducer = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_AGENT_POLICY_MANUAL_PRICING":
      return action.payload;
    // ...
    default:
      return state;
  }
};

const CurrentTimeSlotOrdersReducer = (state = {}, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_CURRENT_TIME_SLOT_ORDERS":
      return action.payload;
    case "CLEAR_CURRENT_TIME_SLOT_ORDERS":
      return {};
    // ...
    default:
      return state;
  }
};

const ExistingOrder = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_EXISTING_ORDER":
      return action.payload;
    // ...
    default:
      return state;
  }
};
const ExistingOrderCartItems = (state = null, action) => {
  // Handle actions related to user
  switch (action.type) {
    case "UPDATE_EXISTING_ORDER_CART_ITEMS":
      return action.payload;
    // ...
    default:
      return state;
  }
};

// NEW: Amendment Flow Reducer (Production-Safe)
const amendmentFlowReducer = (state = {
  isAmendmentFlow: false,
  existingOrder: null,
  existingOrderItems: [],
  userDetails: null,
  detailsAlreadyCollected: false
}, action) => {
  switch (action.type) {
    case "SET_AMENDMENT_FLOW":
      return {
        ...state,
        isAmendmentFlow: true,
        existingOrder: action.payload.existingOrder,
        existingOrderItems: action.payload.existingOrderItems || [],
        userDetails: action.payload.userDetails,
        detailsAlreadyCollected: true
      };
    case "CLEAR_AMENDMENT_FLOW":
      return {
        isAmendmentFlow: false,
        existingOrder: null,
        existingOrderItems: [],
        userDetails: null,
        detailsAlreadyCollected: false
      };
    case "STORE_USER_DETAILS":
      return {
        ...state,
        userDetails: action.payload,
        detailsAlreadyCollected: true
      };
    default:
      return state;
  }
};

// Combine the reducers into a root reducer
const rootReducer = combineReducers({
  cartItems: cartItemsReducer,
  selectedBrand: selectedBrandReducer,
  selectedCategory: selectedCategoryReducer,
  brands: BrandListReducer,
  categories: CategoryListReducer,
  products: ProductListReducer,
  userProfile: UserProfileReducer,
  sessionToken: SessionTokenReducer,
  thankYouMessage: ThankYouMessageReducer,
  agent: AgentReducer,
  selectedStore: SelectedStoreReducer,
  deliveryTimeSlots: DeliveryTimeSlotReducer,
  totalCost: TotalCostReducer,
  checkoutComment: CheckoutCommentReducer,
  selectedTimeSlot: SelectedTimeSlotReducer,
  surchargeChargeList: SurchargeChargeListReducer,
  deliveryChargeList: DeliveryChargeListReducer,
  exclusivePromotionChargeList: ExclusivePromotionChargeListReducer,
  concurrentPromotionChargeList: ConcurrentPromotionChargeListReducer,
  requiredDeliveryCharges: RequiredDeliveryChargesReducer,
  requiredSurchargeCharges: RequiredSurchargeChargesReducer,
  requiredExclusivePromotionCharges: RequiredExclusivePromotionChargesReducer,
  requiredConcurrentPromotionCharges: RequiredConcurrentPromotionChargesReducer,
  csrfToken: CSRFTokenReducer,
  selectedProductType: SelectedProductTypeReducer,
  productTypeList: ProductTypeListReducer,
  routeDetails: RouteDetailsReducer,
  baseManualPricing: BaseManualPricingReducer,
  agentPolicyManualPricing: AgentPolicyManualPricingReducer,
  currentTimeSlotOrders: CurrentTimeSlotOrdersReducer,
  existingOrderCartItems: ExistingOrderCartItems,
  existingOrder: ExistingOrder,
  amendmentFlow: amendmentFlowReducer,
});

export default rootReducer;
